import { Operation } from 'data/types';
import * as types from 'data/sipSetting/sipSetting.types';

type Type = {
  id?: string,
  operation?: Operation,
}

export const adaptSipSettingOperation = <T extends Type>(
  data: T,
  changedData: { [key: string]: boolean },
  keepOPeration: boolean,
  ): T => {

  if (keepOPeration) {
    return data;
  }

  if (!changedData[data.id as string] && !data?.id?.includes('DX_PREFIX_ID') && !data?.id?.includes('DX_NET_ID')) {
    return {
      ...data,
      operation: 'NO_OPERATION'
    }
  }

  if (data.operation == null || (data.operation !== 'CREATE' && data.operation !== 'DELETE')) {
    return {
      ...data,
      operation: 'UPDATE'
    }
  }

  return data;
}

export const removeNewMoWithDeleteOperation = <T extends Type>(data: T): boolean => {
  if (data.operation === 'DELETE' && (data?.id?.includes('DX_PREFIX_ID') || data?.id?.includes('DX_NET_ID'))) {
    return false;
  }

  return true;
}

export const adaptSipPrefixRowData = <T extends Type>(data: T, controller: number, tempId: string): T => {

  if (data.id != null && data.id !== '') {
    return data;
  }

  controller += 1;
  return {
    ...data,
    id: `${tempId}_${controller}`,
  };
}

export const adaptToRemoveTemporaryId = <T extends Type>(data: T, keepTempId: boolean): T => {
  if (keepTempId) {
    return data;
  }

  if (data?.id?.includes('DX_PREFIX_ID') || data?.id?.includes('DX_NET_ID')) {
    return {
      ...data,
      id: ''
    }
  }

  return data;
}

export const getIncrementalId = <T>(data: T[], param: string): string => {
  const key = param as (keyof T);
  const [last] = data
    .map((item) => Number(item[key]))
    .filter((item) => !Number.isNaN(item)).sort((x: number, y: number) => x - y)
    .reverse();

  return ((last || 0) + 1).toString();
}
